import React from "react";
import ClientAppSidebar from "../../../../components/ClientAppSidebar";
import { MonthAtGlanceSection } from "../components/client_overview_components/MonthAtGlanceSection";
import { NeedsYourAttentionSection } from "../components/client_overview_components/NeedsYourAttentionSection";
import { ThisMonthInProgressSection } from "../components/client_overview_components/ThisMonthInProgressSection";
import { TwelveMonthTrendSection } from "../components/client_overview_components/TwelveMonthTrendSection";
import { ArApAgingSection } from "../components/client_overview_components/ArApAgingSection";

import { useClientOverviewBootstrap } from "../hooks/useClientOverviewBootstrap";
import {
  getEffectiveMonth,
  getEffectiveYear,
} from "../../../../utils/effectiveDate";
import { AccountantStatusSummaryCards } from "../../../../pages/accountant_status/AccountantStatusSummaryCards";

/**
 * Client Overview page. Each section owns its own data (mock for now; hooks later).
 * Page is layout-only: sidebar + container + section components with no props.
 */
export default function ClientOverviewPage() {
  useClientOverviewBootstrap();

  return (
    <div className="flex w-full items-start h-screen">
      <ClientAppSidebar />
      <div className="flex grow shrink-0 basis-0 flex-col items-start gap-4 self-stretch bg-default-background overflow-y-auto">
        <div className="container max-w-none flex w-full min-w-0 grow shrink-0 basis-0 items-start gap-8 bg-neutral-50 py-12 overflow-auto">
          <div className="flex min-w-0 grow shrink-0 basis-0 flex-col items-start gap-8 w-full max-w-full">
            <div className="flex w-full items-center justify-between">
              <span className="text-heading-1 font-heading-1 text-default-font">
                Overview
              </span>
            </div>
            <ThisMonthInProgressSection />
            <div className="flex w-full flex-col items-start gap-4">
              <span className="text-caption-bold font-caption-bold text-neutral-500 uppercase tracking-widest">
                Accounting Status
              </span>
              <AccountantStatusSummaryCards
                year={getEffectiveYear()}
                month={getEffectiveMonth()}
              />
            </div>
            <NeedsYourAttentionSection />
            <MonthAtGlanceSection />

            {/* <FinancialPositionSection /> */}
            <TwelveMonthTrendSection />
            <ArApAgingSection />
            {/* <div className="flex w-full gap-8 items-stretch">
              <RevenueConcentrationSection />
              <ReceivablesAgingSection />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
